import { useNostr } from './useNostr';
import { useQuery } from '@tanstack/react-query';

/**
 * Hook to fetch the list of pubkeys that a given user follows (kind 3 contact list).
 * Kind 3 is a single replaceable event — all follows are in it, no pagination needed.
 */
export function useFollowingList(pubkey: string) {
  const { nostr } = useNostr();

  const { data: followEvent, isLoading } = useQuery({
    queryKey: ['following-list', pubkey],
    queryFn: async () => {
      if (!nostr) return null;
      const events = await nostr.query([
        { kinds: [3], authors: [pubkey], limit: 1 },
      ]);
      return events[0] || null;
    },
    enabled: !!pubkey && !!nostr,
    staleTime: 5 * 60 * 1000, // 5 min cache
  });

  // Extract all p-tagged pubkeys from the contact list
  const pubkeys = followEvent
    ? followEvent.tags
        .filter(([name]) => name === 'p')
        .map(([_, pk]) => pk)
    : [];

  return {
    pubkeys,     // string[] — full list of followed pubkeys
    count: pubkeys.length,
    isLoading,
  };
}